import { vendorsPortalApi } from 'src/services/api/vendorsPortalApi';

export class PriceEngineService {
  static async firstOrderDiscount() {
    return vendorsPortalApi
      .get('/api/prices/discounts/first-order')
      .then(response => response.data);
  }
}
